<script>
  import Footer from "$components/common/Footer.svelte";
  import Nav from "$components/common/Nav.svelte";

</script>

<div class="w-full h-full overflow-y-auto relative bg-white">
  <div class="absolute top-0 left-0 right-0 z-10 w-full border-b border-white/20">
    <div class="max-w-[1312px] mx-auto">
      <Nav />
    </div>
  </div>
  <slot></slot>
  <Footer />
</div>

<style>
</style>
